import React, { useEffect, useState } from 'react';
import { Card, message } from 'antd';
import { getSoloEvents } from '../../api/event';
import SoloEventsTable from './soloEventsTable/soloEventsTable';

const computeAge = (dateOfBirth) => {
    if (!dateOfBirth) return 0;
    const today = new Date();
    const dob = new Date(dateOfBirth);
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
    return age;
};

const EventSelector = ({ contestant, onSelectEvent, selectedEvents }) => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const soloEvents = await getSoloEvents();

                // Restrict Commercial Modelling to male contestants aged 16+
                const gender = (contestant?.gender || '').toLowerCase();
                const age = contestant?.age != null
                    ? Number(contestant.age)
                    : computeAge(contestant?.date_of_birth);
                const isMale16Plus = gender === 'male' && age >= 16;
                const isFemale16Plus = gender === 'female' && age >= 16;

                const filtered = soloEvents.filter((ev) => {
                    const evName = (ev.name || '').toLowerCase().trim();
                    const evStyle = (ev.style || '').toLowerCase();
                    if (evName === 'modelling' && evStyle.includes('commercial') && !isMale16Plus) {
                        return false;
                    }
                    if (evName === 'modelling' && (evStyle.includes('petite') || evStyle.includes('plus')) && !isFemale16Plus) {
                        return false;
                    }
                    return true;
                });

                setEvents(filtered);
            } catch (error) {
                console.error('Error fetching solo events:', error);
                message.error('Failed to fetch events');
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, [contestant]);

    if (!contestant) {
        return <div>No contestant data available.</div>;
    }

    return (
        <div title="Select Events">
            <SoloEventsTable
                events={events}
                loading={loading}
                openPopup={(event) => console.log("Apply to event:", event)}
                userRole="contestant" // Adjust the role as necessary  
                handleDeleteEvent={(eventId) => console.log("Delete event:", eventId)}
                onSelectEvent={onSelectEvent}
                selectedEvents={selectedEvents} // Make sure this is correctly passed  
            />
        </div>
    );
};

export default EventSelector;  
